import { Col, Row, Switch, TimePicker } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import s from '../styles';

function Day({ day, length, index, editing }) {
  const { t } = useTranslation();
  const [isClose, setIsClose] = useState(false);

  const onChange = (checked) => {
    setIsClose(checked);
  };

  return (
    <>
      <Row style={{ height: '47px' }}>
        <Col span={5} style={{ display: 'flex', alignItems: 'center' }}>
          <s.text>{day}</s.text>
        </Col>
        <Col span={5} style={{ display: 'flex', alignItems: 'center' }}>
          {!isClose ? (
            <s.textSwitch>
              {t('containers.SettingsStoreHours.close')}
            </s.textSwitch>
          ) : (
            <s.textSwitch>
              {t('containers.SettingsStoreHours.open')}
            </s.textSwitch>
          )}
          <Switch disabled={!editing} checked={isClose} onChange={onChange} />
        </Col>
        {isClose && (
          <Col span={14} style={{ display: 'flex' }}>
            <TimePicker.RangePicker
              style={{ marginRight: '53px' }}
              bordered={false}
              format="HH:mm"
              placeholder={[
                t('containers.SettingsStoreHours.start'),
                t('containers.SettingsStoreHours.end'),
              ]}
            />
            <TimePicker.RangePicker
              bordered={false}
              format="HH:mm"
              placeholder={[
                t('containers.SettingsStoreHours.start'),
                t('containers.SettingsStoreHours.end'),
              ]}
            />
          </Col>
        )}
      </Row>
      {index === length - 1 ? (
        <s.spacePadding />
      ) : (
        <s.secondLine />
      )}
    </>
  );
}

export default Day;
